import removeJobIDfromLocalstorageCommon from "./removeJobIDfromLocalstorage.common";
import showSavedJobsCount from "../../search-interface/_imports/career/show-saved-jobs-count";
import dataLayerCareerSavedJobs from "../dataLayers/careers-saved-job.common";
import dataLayersCareer from "../dataLayers/careers-details-page-saved-job.common";
import { logSaveJobFromJobDetailsPage } from "../amplitude/job-interactions.common";
import { logUnSaveJobFromJobDetailsPage } from "../amplitude/job-interactions.common";
import { logSaveorUnsaveJobFromCareersResultPage } from "../amplitude/job-interactions.common";

const updateSaveJobButtonLabel = (element) => {
	const iconSavedButtonParent = element.closest('.saved-jobs-icon');

	if (!iconSavedButtonParent.className.includes('is-saved') || window.careerJobWasSaved) {
		iconSavedButtonParent.classList.add('is-saved');
		iconSavedButtonParent.setAttribute('data-job-is-saved', true);
		dataLayersCareer().savedJob();
		logSaveJobFromJobDetailsPage();
	} else {
		iconSavedButtonParent.classList.remove('is-saved');
		iconSavedButtonParent.removeAttribute('data-job-is-saved');

		dataLayersCareer().unsavedJob();
		logUnSaveJobFromJobDetailsPage();
	}
};

const saveJob = (jobID) => {
	const getSavedJobsLocalstorage = localStorage.getItem(`careerSavedJobsID_${lang}`);
	let savedJobsID = getSavedJobsLocalstorage ? JSON.parse(getSavedJobsLocalstorage) : [];

	savedJobsID.push(jobID);
	savedJobsID = Array.from(new Set(savedJobsID));

	localStorage.setItem(`careerSavedJobsID_${lang}`, JSON.stringify(savedJobsID));
};

const addSavedJob = (event) => {
	const element = event.target;
	const jobID = $(element).closest('.CoveoResult').find('[data-ghid]').data('ghid') || greenhouseItemName;

	if (element.dataset.btn.includes('career-saved-jobs')) {
		const saveJobIcon = event.target.parentElement;

		if (document.documentElement.dataset.page === "career-search") {
			if (saveJobIcon.className.includes('is-saved')) {
				saveJobIcon.classList.remove('is-saved');
				saveJobIcon.removeAttribute('data-job-is-saved');

				removeJobIDfromLocalstorageCommon(jobID);
				showSavedJobsCount();

				return;
			}

			saveJobIcon.classList.add('is-saved');
			saveJobIcon.setAttribute('data-job-is-saved', true);

			saveJob(jobID);

			showSavedJobsCount();
		} else {
			//When the job was previously saved in the search results page
			if (window.careerJobWasSaved) {
				window.careerJobWasSaved = false;

				removeJobIDfromLocalstorageCommon(jobID);
				showSavedJobsCount();
				updateSaveJobButtonLabel(element);

				return;
			}

			// When saving a job from the job details page
			window.careerJobWasSaved = true;

			saveJob(jobID);
			showSavedJobsCount();
			updateSaveJobButtonLabel(element);
		}
	}
};

const buttonsSaveJobs = () => {
	const results = document.querySelectorAll('.CoveoResult [data-btn="career-saved-jobs"]');
	const btnSavedJobDetails = document.querySelectorAll('.apply-container [data-btn="career-saved-jobs"]')[0];
	const jobsList = localStorage.getItem(`careerSavedJobsID_${lang}`);

	//Page open positions
	if (results) {
		for (let result of results) {
			result.addEventListener('click', (event) => {
				addSavedJob(event);
				dataLayerCareerSavedJobs(event);
				logSaveorUnsaveJobFromCareersResultPage(event);
			});
		}
	}
	//Page Job Details
	if (btnSavedJobDetails) {
		btnSavedJobDetails.addEventListener('click', (event) => {
			event.preventDefault();
			addSavedJob(event);
		});

		if (jobsList && jobsList.includes(greenhouseItemName)) {
			updateSaveJobButtonLabel(btnSavedJobDetails);
		}

		showSavedJobsCount({
			onload: true
		});
	}
};

export default buttonsSaveJobs;